import Menu from './Menu'
import Map from './Map'

export default {
  Menu,
  Map
}